<template>
  <!-- 剧集抽屉 -->
  <a-drawer
    title="更换短剧"
    width="700"
    :closable="false"
    :visible="visible"
    @close="onClose"
    :footer-style="{ textAlign: 'right' }"
  >
    <!-- 表单数据 -->
    <a-form
      name="form"
      ref="RefForm"
      :model="formState"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 18 }"
    >
      <!-- 短剧 -->
      <a-form-item
        label="短剧"
        name="id"
        :rules="[{ required: true, message: '请选择' }]"
      >
        <a-select
          show-search
          v-model:value="formState.id"
          placeholder="请选择"
          :filter-option="filterOption"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        >
          <a-select-option v-for="item in dramas" :key="`${item.playlet_id} - ${item.name}`" :value="item.playlet_id">{{ item.name }}</a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
    <!-- 尾部 -->
    <template #footer>
      <a-button style="margin-right: 8px" @click="onClose">取消</a-button>
      <a-button type="primary" @click="touchSubmit">确定</a-button>
    </template>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
  </a-drawer>
</template>

<script setup>
import { ref, reactive, defineExpose, nextTick } from 'vue'
import { message } from 'ant-design-vue'
import { taskUpdatePlaylet, dramaSelectList } from '@/api/request'
import Loading from '@/components/Loading'

// 回调
const emit = defineEmits('success')
// 表单实例
let RefForm = ref(null)
// 是否展示弹窗
let visible = ref(false)
// 剧集列表
let dramas = ref([])
// 详情
let detail = ref({})
// 表单数据
let formState = reactive({
  // 短剧
  id: undefined,
})
// 加载
let isLoading = ref(false)

// 打开抽屉
function showDrawer (params) {
  // 展开
  visible.value = true
  // 详情
  detail.value = params
  // 赋值
  nextTick(() => {
    if (params.id) {
      // 用户名
      formState.id = params.playlet_id
    }
  })
  // 初始化选择项列表
  getSelectList()
}

// 初始化选择项列表
function getSelectList () {
  dramaSelectList().then(res => {
    const { code, data } = res
    if (code === 0) {
      dramas.value = data
    }
  })
}

// 关闭弹窗
function onClose () {
  // 重置表单
  RefForm.value.resetFields()
  formState.id = undefined
  visible.value = false
}

// 模糊匹配
function filterOption (input, option) {
  return `${option.key}`.toLowerCase().includes(`${input || ''}`.toLowerCase())
}

// 提交
function touchSubmit () {
  // 手动触发表单验证
  RefForm.value.validate()
  .then(() => {
    isLoading.value = true
    taskUpdatePlaylet({
      id: detail.value.id,
      playlet_id: formState.id
    }).then(res => {
      isLoading.value = false
      const { code, msg, data } = res
      if (code === 0) {
        message.success('操作成功')
        // 更新父组件
        emit('success')
        // 关闭弹窗
        onClose()
      } else {
        message.error(res.message || msg)
      }
    })
  })
}

defineExpose({
  showDrawer
})

</script>

<style lang="less" scoped>
.form-upload-list {
  display: flex;
  flex-wrap: wrap;
  margin-left: -10px;
}
.image-view.form-upload-item {
  position: relative;
  margin-top: 10px;
  margin-left: 10px;
  width: 118px;
  height: 148px;
  border-radius: 4px;
  overflow: hidden;
}
</style>